import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { fetchFooter } from '../../containers/common/commonSlice'
import { getCurrentLocal } from '../../utils';
import { analyticsProdTrackingID, analyticsProdURL, analyticsStageTrackingID, analyticsStageURL } from '../../constants';

export const Footer = () => {
    const dispacth = useDispatch();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pageType = urlParams.get('page-type');
    const searchTerm = urlParams.get('q');
    const [footerHTMLCode, setFooterHtmlCode] = useState("");
    const footerHTML = useSelector((state) => state.common.footerHTML);
    const searchResultsApiResponse = useSelector((state) => state?.searchLanding?.search?.searchResults);
    const filterBy = "All";
    //const [newfooterHTMLCode, setNewfooterHTMLCode] = useState("");

    // const domain = window.origin
    const pathName = window.location.pathname;
    const getlocales = window.location.href 
    const matchLocal = getlocales.match(/\/([a-z]{2}-[a-z]{2})\//i);
    const locale = matchLocal ? matchLocal[1] : 'en-US';

    const isMobile = window.screen.width < 768;

    useEffect(() => {
        let currentLocale = getCurrentLocal();
        dispacth(fetchFooter(currentLocale.toLowerCase()))
        //dispacth(fetchFooter('en-us'))

    }, [])

    useEffect(() => {
        if (footerHTML) {
            let footerBody = footerHTML.querySelector("body");
            setFooterHtmlCode(footerBody.innerHTML);
            setTimeout(() => {
                if (footerHTML) {
                    hederJs();
                }
            }, 500)
        }
    }, [footerHTML])

    useEffect(() => {
        if(searchResultsApiResponse?.total && window?.utag_data?.searchTermsCount == "0"){
            window.utag_data = {
                ...window.utag_data,
                searchTermsCount: searchResultsApiResponse.total
            }
        }
    },[searchResultsApiResponse, window.utag_data])

    function getPreviousPageDomain() {
        const ref = document.referrer;
        if (!ref) return null;

        try {
            return new URL(ref).hostname;
        } catch (e) {
            return null;
        }
    }

    function getCurrencyFromLocale(locale) {
        const localeCurrencyMap = {
            'en-us': 'USD',
            'en-gb': 'GBP',
            'en-in': 'INR',
            'fr-fr': 'EUR',
            'de-de': 'EUR',
            'ja-jp': 'JPY',
            'zh-cn': 'CNY',
            'ko-kr': 'KRW',
            'es-es': 'EUR',
            'it-it': 'EUR',
            'ru-ru': 'RUB',
            'pt-br': 'BRL',
            'ar-sa': 'SAR',
            // Add more as needed
        };

        return localeCurrencyMap[locale] || 'USD'; // fallback to USD
    }



    const hederJs = () => {
        var script = document.createElement('script');
        script.src = '/etc.clientlibs/sndsk/clientlibs/sd/common/clientlib-header-footer-react.min.js';
        script.async = true;
        var footer = document.querySelector('footer');
        footer?.appendChild(script);


        console.log(pathName);
        if (!window.utag_data) {
            // let totalResults = document.getElementById("totalResults");
            window.utag_data = {
                ...window.utag_data,
                analyticsTrackingID: analyticsStageTrackingID,
                currencyISO: getCurrencyFromLocale(locale),
                eventName: "PAGE_LOAD",
                pageBrand: ['SanDisk'],
                pageLocale: locale.split("-")[0]+"-"+locale.split("-")[1].toUpperCase(),
                pageName: !matchLocal ? 'en-us' + pathName + (pageType ? '/' + pageType.toLowerCase().replace(' ','-') : '') : (pathName + (pageType ? '/' + pageType.toLowerCase().replace(' ','-') : '')).slice(1),
                pageSection: !matchLocal ? pathName.split("/")[1] : pathName.split("/")[2],
                pageType: "company-page-vue",
                siteID: `SanDisk - ${locale.split("-")[1].toUpperCase()}`,
                sitePlatform: isMobile ? "Mobile" : "Desktop",
                thumbnailURL: "",
                productReferrer: getPreviousPageDomain()
            }
            if(pathName === "/search"){
                window.utag_data = {
                    ...window.utag_data,
                    pageType: "page-container-vue",
                }
            }
            if(searchTerm) {
             const observer = new MutationObserver((mutations, obs) => {
                const totalResults = document.getElementById("totalResults");
                if(totalResults) {
                    window.utag_data = {
                         ...window.utag_data,
                         searchTerm: searchTerm,
                         q: searchTerm,
                         filterBy: filterBy,
                         searchTermsCount: totalResults.innerHTML
                         }
                          if(window.location.pathname === '/search' && window.aa.loadAllTags === false){
                             window.aa.loadAllTags = true
                            }
                            if(trackInternalSearch){
                                trackInternalSearch(searchTerm, totalResults.innerHTML, filterBy);
                            }
                            obs.disconnect(); 
                            }
                        });
                        observer.observe(document.body, { childList: true, subtree: true });
            }
        }


        var scriptAN = document.createElement('script');
        scriptAN.src = analyticsStageURL;
        scriptAN.async = true;
        var head = document.querySelector('head');
        head?.appendChild(scriptAN);




    }

    function trackInternalSearch(q, numFound, filterBy) {
            var searchObj = {}
            searchObj["q"] = q;
            if(numFound == "0" || numFound == 0){
                searchObj["searchTermsCount"] = numFound;
            }
            searchObj["filterBy"] = [];
            searchObj["filterBy"] = filterBy != '' ? decodeURIComponent((filterBy).replace(new RegExp('%22', 'g'), '').split("OR")).split(",") : 'All';
            try {
                // var event = window.aa.createEvent("SEARCH", searchObj);
                // window.dispatchEvent(event);
            } catch (e) {
                console.log(e,"Error while triggering analytics Search event.");
            }
    }


    return (
        <React.Fragment>
            {/* <footer className="sd-max-h-max target-section1 sd-text-white sd-bg-black sd-flex sd-flex-col sd-justify-between sd-z-20 sd-relative">
                <div className="sd-container-fluid sd-mx-auto">
                    <div className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-16 sd-gap-4 sd-pt-5 sd-text-para sd-text-gray-101">
                        <div className="sd-col-span-8 lg:sd-col-span-6">
                            <span className="sd-block sd-whitespace-nowrap">Get our newsletter for offers,product
                                previews<br />and behind the scenes content.</span>
                            <div className="sd-flex sd-justify-between sd-items-center sd-mt-9">
                                <span className="sd-flex sd-items-center">YOUR EMAIL<span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-ml-[6px] sd-bg-gray-101">&nbsp;</span></span>
                                <span>SIGN UP</span>
                            </div>
                        </div>
                        <div className="sd-grid sd-grid-cols-subgrid sd-grid-cols-16 lg:sd-grid-cols-8 sd-gap-16 lg:sd-gap-4 lg:sd-col-span-16 sd-col-span-8 lg:sd-col-start-9">
                            <div className="sd-col-span-8 lg:sd-col-span-2">
                                <span className="sd-block sd-mb-3 sd-px">HELP</span>
                                <ul>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        resource library</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        product security</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        discounts &amp; promotions</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        warranty policy</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        return policy</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        financing options</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        distributors &amp; resellers</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        FAQ</li>
                                </ul>
                            </div>
                            <div className="sd-col-span-8 lg:sd-col-span-2">
                                <span className="sd-block sd-mb-3 sd-px">ABOUT</span>
                                <ul>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        overview</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        responsibility</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        category</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        programs</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        contact</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        newsroom</li>
                                </ul>
                            </div>
                            <div className="sd-col-span-8 lg:sd-col-span-2">
                                <span className="sd-block sd-mb-3 sd-px">INFO</span>
                                <ul>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        privacy</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        legal</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        cookie statement</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        about ads</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        trademark</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        terms of sale</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        product compliance</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        cookie preferences</li>
                                </ul>
                            </div>
                            <div className="sd-col-span-8 lg:sd-col-span-2">
                                <span className="sd-block sd-mb-3 sd-px">SOCIAL</span>
                                <ul>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        instagram</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        linkedin</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        x</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        facebook</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        youtube</li>
                                    <li className="capitalize sd-w-fit sd-cursor-pointer hover:sd-text-black sd-whiteBgHover sd-relative sd-pr-3">
                                        newsroom</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="sd-mt-10 sd-mb-10 lg:sd-mb-4">
                        <div className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-16 sd-gap-4">
                            <div className="lg:sd-col-span-16 sd-col-span-8">
                                <img className="sd-w-full" src="https://static.sandisk.com/etc.clientlibs/sndsk-static/designs/images/logo/footer-logo.svg" alt="No Preview" />
                                <div className="sd-flex sd-justify-between sd-items-start sd-mt-2">
                                    <span className="sd-w-1/4">COPYRIGHT 20-25</span>
                                    <div className="sd-w-1/3 sd-text-left">
                                        <span>37° 26' 4"<br />N 121° 53' 42"&nbsp;O</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-16 sd-mt-7 sd-relative">
                            <div className="lg:sd-col-span-16 sd-col-span-7">
                                <div className="sd-grid sd-grid-cols-8 lg:sd-grid-cols-16 sd-relative">
                                    <div className="sd-col-span-2 lg:sd-col-span-3 sd-aspect-square sd-max-h-max sd-max-w-full sd-min-h-16 sd-min-w-16 sd-rounded-full sd-bg-gray-101 sd-px-4 sd-pt-[22px] sd-relative">
                                        <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd--top-[22px]">&nbsp;</span>
                                        &nbsp;
                                    </div>
                                    <div className="sd-col-span-2 lg:sd-col-span-3 sd-aspect-square sd-max-h-max sd-max-w-full sd-min-h-16 sd-min-w-16 sd-rounded-full sd-bg-gray-101 sd-px-4 sd-pt-[22px] sd-relative">
                                        <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd--top-[22px]">&nbsp;</span>
                                        &nbsp;
                                    </div>
                                    <div className="sd-col-span-4 lg:sd-col-span-7 sd-max-h-full sd-max-w-[671px] sd-min-h-16 sd-min-w-[171px] sd-rounded-full sd-bg-gray-101 sd-px-4 sd-pt-[22px] sd-relative">
                                        <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd--top-[22px]">&nbsp;</span>
                                        &nbsp;
                                        <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd--top-[22px] sd-right-0">&nbsp;</span>
                                    </div>
                                </div>
                            </div>
                            <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd--top-[22px] sd-right-0">&nbsp;</span>
                            &nbsp;
                            <span className="sd-h-[9px] sd-w-[9px] sd-inline-block sd-mr-[6px] sd-bg-gray-101 sd-absolute sd-right-0 sd-bottom-0">&nbsp;</span>

                        </div>
                    </div>
                </div>
            </footer> */}
            <footer dangerouslySetInnerHTML={{ __html: footerHTMLCode }}>
            </footer>
        </React.Fragment>
    );
}

export default Footer;